
import './viewAllAssignedStakeholders.css';
import React, { useState, useEffect } from "react";

import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS } from '../../../common/URLs';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Fab, IconButton, Tooltip } from '@mui/material';
import { PROD, ROLES } from '../../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { DialogContent, Dialog } from '@mui/material';
import { OTPValidationPopover } from '../../../preregcamps/confirmPopover/otpValidationPopover';
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { EditIcon, ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ViewAllClarifications() {
  const { t } = useTranslation();
  const [stakeHolders, setStakeHolders] = useState();
  const [viewClarifications, setViewClarifications] = useState();
  const [userID, setUserId] = useState();
  const [urn, setUrn] = useState();
    const [mobileNumber, setMobileNumber] = useState();
    const [editMode, setEditMode] = useState();
    const [stakeHolderSubCategory, setStakeHolderSubCategory] = useState();
    const [stakeholderType, setStakeholderType] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
  useEffect(() => {
    setUserId(location.state.userid);

  }, []);
  let role = localStorage.getItem('role');

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state.userid;
  const backScrutiny = location.state.backScrutiny;

  useEffect(() => {
    if (userId) {
      getAllClarifications();
    }
  }, [userId]);
  const onView = (urnSelected, createdBy, stakeholderType, growerSubCategory) => {
    const userData = {
      "urnSelected": urnSelected,
      "createdBy": createdBy,
      "userId": userId,
      "submitClarification": "yes",
      "isScrutinyView": true

    }
    if (backScrutiny === true) {
      if(stakeholderType === "Transporter") {
        navigate("/registrationHome/scrutiny/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "HIT") {
        navigate("/registrationHome/scrutiny/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "LLE") {
        navigate("/registrationHome/scrutiny/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "Interim Storage Operator") {
        navigate("/registrationHome/scrutiny/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected } });
      }
     else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
        navigate("/registrationHome/scrutiny/registrationDetails", { state: { data: userData, URN: urnSelected } });
      }
     else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
        navigate("/registrationHome/scrutiny/registrationMemberDetails", { state: { data: userData, URN: urnSelected } });
      }
      else if (growerSubCategory === "Forest") {
        navigate("/registrationHome/scrutiny/registrationDetailsForest", { state: { data: userData, URN: urnSelected } });
      }
      else {
        // navigate("/registrationHome/scrutiny/onView", { state: { data: userData } })
      }
    }
    else {
      if(stakeholderType === "Transporter") {
        navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
      }
     else if(stakeholderType === "HIT") {
        navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "LLE") {
        navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
      }
     else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
        navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected } });
      }
      else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
        navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected } });
      }
      else if (growerSubCategory === "Forest") {
        navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected } });
      }
      else {
        // navigate("/registrationHome/dashboard/onView", { state: { data: userData } })
      }
    };
    // {backScrutiny === true ? navigate("/registrationHome/scrutiny/registrationDetails", { state: { data: userData, URN: urnSelected } }) : navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected } })};
  }
  function getAllClarifications() {
    apiClient
      .post(GET_APPLICATION_LIST,
        {
          "userID": userId,
          "status": "Pending_Clarification",
          "regStatus": location?.state?.isResourceUpdate
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setViewClarifications(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const clarificationsArray = viewClarifications?.scrutinyWorkFlowStepDetails;

  const onRegister = (urn1, mobileNumber, subCategory, stakeHolderType, edit_mode) => {
    //setStakeHolderSubCategory(subCategory);
    //setStakeholderType(stakeHolderType);
    //setUrn(urn);
    //setMobileNumber(mobileNumber);
    //setEditMode(editmode);
    //handleLogModalOpen();
      if (subCategory == "Grower" || subCategory == "Individual" || subCategory == "JFMC" || subCategory === "Other Agency") {
          navigate("/registrationHome/registration/registrationDetails", { state: { URN: urn1, editmode: edit_mode } });
      }
      else if (subCategory == "Forest") {
          navigate("/registrationHome/registration/personalDetailsForest", { state: { URN: urn1, editmode: edit_mode } })
      } else if (subCategory === "Co-operative" || subCategory === "FPO" || subCategory === "SHG" || subCategory === "FPC") {
          navigate("/registrationHome/registration/registrationMemberDetails", { state: { URN: urn1, stakeHolderSubCategory: subCategory, editmode: edit_mode } })
      }
      else if (subCategory === "Forest") {
        navigate("/registrationHome/registration/registrationDetailsForest", { state: { URN: urn1, stakeHolderSubCategory: subCategory, editmode: edit_mode } })
    }
      else if (stakeHolderType === "HIT") {
          navigate("/hitRegistration", { state: { URN: urn1 } })
      }
      else if (stakeHolderType === "Transporter") {
          navigate("/hitRegistration", { state: { URN: urn1 } })
      }
      else if (stakeHolderType === "LLE") {
          navigate("/lleMainPage", { state: { URN: urn1 } })
      }
      else if (stakeHolderType === "Interim Storage Operator") {
          navigate("/hitRegistration", { state: { URN: urn1 } })
      }
}
const onOTPValidated = (urn, onClose) => {
  onClose();
  console.log("otp validated")
  if (stakeHolderSubCategory == "Grower" || stakeHolderSubCategory == "Individual" || stakeHolderSubCategory == "JFMC" || stakeHolderSubCategory === "Other Agency") {
      navigate("/registrationHome/dashboard/registrationDetails", { state: { URN: urn, editmode: editMode, registerByScruOtpValidated: true } });
  }
  else if (stakeHolderSubCategory == "Forest") {
      navigate("/registrationHome/dashboard/personalDetailsForest", { state: { URN: urn, editmode: editMode } })
  } else if (stakeHolderSubCategory === "Co-operative" || stakeHolderSubCategory === "FPO" || stakeHolderSubCategory === "SHG" || stakeHolderSubCategory === "FPC") {
      navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { URN: urn, stakeHolderSubCategory: stakeHolderSubCategory, editmode: editMode } })
  }
  else if (stakeHolderSubCategory === "Forest") {
    navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { URN: urn, stakeHolderSubCategory: stakeHolderSubCategory, editmode: editMode } })
}
  else if (stakeholderType === "HIT") {
      navigate("/hitRegistration", { state: { URN: urn } })
  }
  else if (stakeholderType === "Transporter") {
      navigate("/hitRegistration", { state: { URN: urn } })
  }
  else if (stakeholderType === "LLE") {
      navigate("/lleMainPage", { state: { URN: urn } })
  }
  else if (stakeholderType === "Interim Storage Operator") {
      navigate("/hitRegistration", { state: { URN: urn } })
  }
  else{
    alert(stakeHolderSubCategory);
  }
}

  const columns = [
    {
      field: 'id', headerName: 'S.No', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
    },
    { field: 'name', headerName: t('preReg.name'), width: 180 },
    { field: 'urn', headerName: 'URN', width: 150, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
    { field: 'registrationStatus', headerName: 'Status', width: 180 },
    { field: 'totalQuantity', headerName: 'Total Quantity (in MT)', width: 140, type: "number" },
    { field: 'committedQuantity', headerName: 'Committed Quantity (in MT)', width: 140, type: "number" },
    {
      field: 'action', headerName: 'Action', width: 180,
      renderCell: (cellValues) => {
        return (
          <div>
         {role !== ROLES.RegistrationScruitnizer &&  
         <Tooltip title="View">
         <IconButton
            color="primary"
            onClick={() => onView(cellValues?.row?.urn, cellValues?.row?.createdBy, cellValues?.row?.stakeholderType, cellValues?.row?.stakeholderSubCategory)}
          >
            <ViewIcon/>
          </IconButton>
          </Tooltip>} &nbsp;&nbsp;&nbsp;&nbsp;
     {role === ROLES.RegistrationScruitnizer && 
     <Tooltip title="Edit">
     <IconButton
            color="primary"
             onClick={() => onRegister(cellValues?.row?.urn, cellValues?.row?.mobileNumber, cellValues?.row?.stakeholderSubCategory, cellValues?.row?.stakeholderType, true)}>
            <EditIcon/>
            </IconButton> 
            </Tooltip>}
            </div>
        );
    }
    },
 
  ];

  return (
    <>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG51</p>}
      <Card>
        <CardContent>
          <div style={{ display: "inline-flex" }}>
            <Typography variant="h4" sx={{ mb: 2 }}>
              <Fab component={RouterLink} to={backScrutiny === true ?'../scrutiny' :'../dashboard'} size="small" aria-label="back" title='Back'>
                <KeyboardArrowLeftRounded />
              </Fab>
            </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div className="hitDetailsText">Pending Clarifications</div>
          </div>
          {clarificationsArray &&
            <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                <DataGrid
                sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "normal"
                    },
                    "& .MuiDataGrid-columnHeader": {
                        height: "unset !important"
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        maxHeight: "168px !important"
                    }
                }}
                rows={clarificationsArray}
                columns={columns}
                pageSize={10}
                getRowId={(row) => row?.id}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            </Box>}
        </CardContent>
      </Card>

      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <OTPValidationPopover onClose={handleLogModalClose} urn={urn} mobileNumber={mobileNumber} callback={onOTPValidated} />
                </DialogContent>
            </Dialog>
    </>
    //   <div>
    //      <Container fluid>
    //                 <Row>
    //     {/* <div className="viewall-sidebar-container">
    //   <ArrowBackIosNew className="arrow-icon"  onClick={() => (navigate(-1))} />
    //   <div className='viewall-div'>
    //       <div className='viewall_sidebar_header_scrutiny'>Pending Clarifications</div>
    //   </div>
    //   <div className='viewall-text'></div>
    // </div> */}
    //                     <Col xs={12} md={12}>
    //                     {!PROD &&  <p style={{textAlign:"center", fontSize:"2vh"}}>REG51</p>}

    // <div style={{display : "inline-flex"}}><Typography variant="h4" sx={{ mb: 2 }}>
    //                     <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'>
    //                     <KeyboardArrowLeftRounded />
    //                     </Fab>
    //                 </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    //                 <div className="hitDetailsText">Pending Clarifications</div></div>
    // {clarificationsArray?.length>0 ?   <div className="table-wrap">
    //       <table className="table-view-class">
    //                   <tr className='tr trStyle'>
    //                       <th className='th colorBlack'>S.No</th>
    //                       <th className='th colorBlack'>Name</th>
    //                       <th className='th colorBlack'>URN</th>
    //                       <th className='th colorBlack'>Stakeholder Type</th>
    //                       <th className='th colorBlack'>Status</th>
    //                       <th className='th colorBlack'>Action</th>
    //             </tr>
    //             {clarificationsArray && clarificationsArray.map((item, index) => {
    //                                             return (
    //                                                 <tr className='tr' key={index}>
    //                                                   <td className='td'>{index+1}</td> 
    //                                                     <td className='td'>{item?.name}</td>
    //                                                     <td className='td'>{item?.urn}</td>
    //                                                     <td className='td'>{item?.stakeholderType}</td>
    //                                                     <td className='td'>{item?.registrationStatus}</td>                                                    
    //                                                     <td className='td'><button className='view-btn' onClick={() => onView(item?.urn,item?.createdBy)}>View</button></td>
    //                                                 </tr>
    //                                             )
    //                                         })}
    //         </table>
    //     </div> : <div className="table-wrap">
    //       <table className="table-view-class"><p className='table-no-data'>No data to display</p></table></div> }
    //       </Col>
    //                 </Row>
    //             </Container>
    //     </div>
  );
}
export default ViewAllClarifications;

